import { StateParams, StateService } from "@uirouter/angularjs";
import {
  MultipleMachineChangeChildStateServiceProvider,
  vsMultiProviderName as MultipleMachineChangeChildStateServiceProviderName,
  SingleMachineChangeChildStateServiceProvider,
  vsSingleProviderName as SingleMachineChangeChildStateServiceProviderName,
} from "../../../shared/components/machineChange";
import { Machine } from "../../models/machine";
import {
  CloneAndConversionService,
  vsServiceName as CloneAndConversionServiceName,
} from "../../services/cloneAndConversionService";
import { cloneDeep } from "lodash";
import {
  FormViewService,
  vsName as FormViewServiceName,
  vsComponentName as FormViewComponentName,
} from "../../../../records/forms/formView";
import { vsComponentName as machinesMoveViewComponentName } from "../../components/views/main/move";
import { vsComponentName as machinesWarehouseViewComponentName } from "../../components/views/main/warehouse";
import { vsComponentName as machinesDecommissionMoveViewComponentName } from "../../components/views/main/decommission";
import { vsComponentName as singleMachineMoveComponentName } from "../../components/views/detail/move";
import { vsComponentName as singleMachineWarehouseComponentName } from "../../components/views/detail/warehouse";
import { vsComponentName as singleMachineDecommissionComponentName } from "../../components/views/detail/decommission";
import { vsComponentName as downloadFileComponentName } from "../../../shared/components/machineDownloadFile";

import angular from "angular";

import { vsModuleName as SharedMachinesModule } from "../../../shared";
import { machineConfigurationObjectName } from "../../../shared/names";
import { MachineEditFormViewConfig } from "../machineConfiguration";
import {
  ChangeJournalModalService,
  vsServiceName as ChangeJournalModalServiceName,
} from "../../../../records/changeJournal/changeNoteModalService";
export const vsModuleName = "SlotTrak.Machines.Config.Change";

export const module = angular.module(
  vsModuleName,
  [SharedMachinesModule],
  [
    SingleMachineChangeChildStateServiceProviderName,
    MultipleMachineChangeChildStateServiceProviderName,
    (
      singleChangeProvider: SingleMachineChangeChildStateServiceProvider,
      multiChangeProvider: MultipleMachineChangeChildStateServiceProvider
    ) => {
      multiChangeProvider
        .addElement({
          displayName: "Clone",
          id: "clone",
          cssClass: "fa fa-clone",
          requiredPermission: "machineEdit",
          uiSrefFragment: "add",
        })
        .addElement({
          displayName: "Convert",
          id: "conversion",
          cssClass: "fa fa-cogs",
          requiredPermission: "machineConvert",
          uiSrefFragment: "main.machines.detail.configurations.conversion",
          absoluteSref: true,
        })
        .addElement({
          displayName: "Move",
          id: "move",
          cssClass: "fa fa-arrows",
          requiredPermission: "machineMove",
          uiSrefFragment: "move",
          stateDefinition: {
            component: machinesMoveViewComponentName,
            url: "/move",
            params: {
              machineConfigurations: undefined,
            },
            resolve: {
              machineConfigurations: resolveMachineConfigurations,
            },
          },
        })
        .addElement({
          displayName: "Warehouse",
          id: "warehouse",
          cssClass: "fa fa-archive",
          requiredPermission: "machineWarehouse",
          uiSrefFragment: "warehouse",
          stateDefinition: {
            url: "/warehouse",
            component: machinesWarehouseViewComponentName,
            params: { machineConfigurations: undefined },
            resolve: { machineConfigurations: resolveMachineConfigurations },
          },
        })
        .addElement({
          displayName: "Decommission",
          id: "decommission",
          cssClass: "fa fa-recycle",
          requiredPermission: "machineDecommission",
          uiSrefFragment: "decommission",
          stateDefinition: {
            url: "/decommission",
            component: machinesDecommissionMoveViewComponentName,
            params: { machineConfigurations: undefined },
            resolve: { machineConfigurations: resolveMachineConfigurations },
          },
        })
        .addElement({
          displayName: "Download File",
          id: "downloadFile",
          cssClass: "fa fa-down",
          requiredPermission: "machineDownloadFile",
          uiSrefFragment: "downloadFile",
          stateDefinition: {
            url: "/downloadFile",
            component: downloadFileComponentName,
            params: {
              machineConfigurations: undefined,
            },
            resolve: {
              machineConfigurations: [
                "$stateParams",
                "$http",
                ($stateParams: StateParams, $http: ng.IHttpService) => {
                  const machineConfigurations = $stateParams.machineConfigurations || [];
                  console.log("Selected Machines:", machineConfigurations);
        
                  const payload = {
                    Machines: machineConfigurations.map((c: any) => ({
                      MachineId: c.MachineId,
                      SerialNumber: c.SerialNumber,
                    })),
                  };
        
                  return $http
                    .post("/api/machines/downloadMachineFile", payload, {
                      responseType: "arraybuffer",
                    })
                    .then((response) => {
                      console.log("Download response:", response);
                      return response;
                    })
                    .catch((error) => {
                      console.error("Download File API Error:", error);
                    });
                },
              ],
            },
          },
        })
        
       singleChangeProvider
        .addElement({
          displayName: "Clone",
          id: "clone",
          cssClass: "fa fa-clone",
          requiredPermission: "machineEdit",
          uiSrefFragment: "main.machines.add",
          absoluteSref: true,
        })
        .addElement({
          displayName: "Convert",
          id: "conversion",
          cssClass: "fa fa-cogs",
          requiredPermission: "machineConvert",
          uiSrefFragment: "conversion",
          stateDefinition: {
            url: "/conversion",
            component: FormViewComponentName,
            params: {
              modelMachineId: undefined,
              modelMachineConfigurationId: undefined,
            },
            resolve: FormViewService.getResolveObjectFromFormViewConfig(
              [
                FormViewServiceName,
                "$state",
                ChangeJournalModalServiceName,
                (
                  formViewService: FormViewService,
                  $state: StateService,
                  changeJournalModalService: ChangeJournalModalService
                ) => {
                  const config = formViewService.getFormViewConfig(
                    machineConfigurationObjectName,
                    <MachineEditFormViewConfig>{
                      machineFieldsEditable: false,
                    }
                  )!;
                  config.submitForm = (args) => {
                    const effectiveModel: any = args.model;
                    return changeJournalModalService
                      .getAndSetChangeJournalNote(effectiveModel.Configuration)
                      .then(() =>
                        formViewService.submitForm({
                          formObject: effectiveModel.Configuration,
                          formViewController: args.formViewController,
                          method: "POST",
                          url: `/api/machines/${effectiveModel.Machine.Id}/conversion`,
                          validationPrefix: "Configuration",
                        })
                      )
                      .then(() => $state.go("^", undefined, { reload: true }));
                  };
                  config.title = () => "Conversion";
                  return config;
                },
              ],
              [
                "machine",
                "$stateParams",
                CloneAndConversionServiceName,
                (
                  machine: Machine,
                  $stateParams: StateParams,
                  cloneAndConversionService: CloneAndConversionService
                ) => {
                  let modelMachineId: number | undefined =
                    $stateParams.modelMachineId;
                  let modelMachineConfigurationId: number | undefined =
                    $stateParams.modelMachineConfigurationId;

                  const currentConfiguration = machine.Configs!.find(
                    (c) => c.CurrentConfiguration
                  )!;

                  const modelMachine = cloneDeep(machine ?? {});
                  delete modelMachine.Configs;

                  return cloneAndConversionService
                    .getConversionConfiguration(
                      currentConfiguration,
                      modelMachineId,
                      modelMachineConfigurationId
                    )
                    .then((conversionConfiguration) => {
                      if (modelMachineConfigurationId === undefined) {
                        conversionConfiguration = {
                          ...conversionConfiguration,
                        };
                      }
                      return {
                        Machine: modelMachine,
                        Configuration: conversionConfiguration,
                      };
                    });
                },
              ]
            ),
          },
        })
        .addElement({
          displayName: "Move",
          id: "move",
          cssClass: "fa fa-arrows",
          requiredPermission: "machineMove",
          uiSrefFragment: "move",
          stateDefinition: {
            url: "/move",
            component: singleMachineMoveComponentName,
          },
        })
        .addElement({
          displayName: "Warehouse",
          id: "warehouse",
          cssClass: "fa fa-archive",
          requiredPermission: "machineWarehouse",
          uiSrefFragment: "warehouse",
          stateDefinition: {
            url: "/warehouse",
            component: singleMachineWarehouseComponentName,
          },
        })
        .addElement({
          displayName: "Decommission",
          id: "decommission",
          cssClass: "fa fa-recycle",
          requiredPermission: "machineDecommission",
          uiSrefFragment: "decommission",
          stateDefinition: {
            url: "/decommission",
            component: singleMachineDecommissionComponentName,
          },
        });
    },
  ]
);

const resolveMachineConfigurations = [
  "$stateParams",
  ($stateParams: StateParams) => $stateParams.machineConfigurations,
];
